// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const loggedUser = localStorage.getItem('loggedUser') != null ? JSON.parse(localStorage.getItem('loggedUser')) : null;
